import React, { useState } from 'react';
import * as actions from '../redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import lupa from "../imgs/lupa.png"
import { useNavigate } from 'react-router-dom';

export default function SearchBar() {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [input, setInput] = React.useState({
    input: ""
  })

  const handleChange = (e) => {
    e.preventDefault()
    setInput({
      ...input,
      input: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    dispatch(actions.search(input.input))
    navigate('/lmi/search')
  }

  return (
    <form class="flex" onSubmit={e => handleSubmit(e)}>

      <input
        type="text"
        name="text"
        value={input.input}
        onChange={e => handleChange(e)}
        class="input"
        placeholder="Buscar..."
        onKeyDown={e => { e.key = "Enter" ? e => handleSubmit(e) : false }} />
      <div onClick={e => handleSubmit(e)}><img class="iconoBuscar" src={lupa} alt="" /></div>
    </form>
  )
};